import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Slide,
  Box,
  Typography,
} from "@mui/material";
import ProjectsSummaryTable from "./ProjectsSummaryTable";
import { TransitionProps } from "@mui/material/transitions";
import PDFUtils from "../../utils/PDFUtils";
import { useSelector } from "react-redux";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface IProps {
  openPDFPreview: boolean;
  handleClosePDFPreview: any;
  data: any;
}

const ProjectSummaryPDFPreview = (props: IProps) => {
  // const [date, setDate] = React.useState<string>()
  const date = useSelector((state: any) => state.base.latestDate);
  const handlePDFDownload = async () => {
    const table = document.getElementById("project-summary-preview-div");
    const pdfUtils = new PDFUtils();
    table &&
      pdfUtils.generatePDF(table, 20, 20).then((pdf) => {
        pdf.save(`projects_summary.pdf`);
      });
  };

  return (
    <Dialog
      fullScreen
      open={props.openPDFPreview}
      onClose={props.handleClosePDFPreview}
      TransitionComponent={Transition}
    >
      <DialogContent>
        <div
          id={"project-summary-preview-div"}
          style={{ display: "block", padding: 10 }}
        >
          <Box
            sx={{
              color: "secondary.main",
              textAlign: "left",
              textTransform: "uppercase",
              letterSpacing: "2px",
              fontWeight: "bold",
              marginBottom: 4,
            }}
          >
            <Typography variant="h3" component="h3">
              4RF Portfolio Summary
            </Typography>
            <Typography variant="h4" component="h4">
              Progress reported on {date}
            </Typography>
          </Box>

          <ProjectsSummaryTable data={props.data} width={600} />
        </div>
        <Box
          sx={{
            color: "secondary.main",
            textAlign: "left",
            // textTransform: 'uppercase',
            letterSpacing: "2px",
            fontWeight: "bold",
            marginBottom: 4,
          }}
        >
          <Typography variant="h6" component="h6">
            4RF Progress Data compiled by Federal RRU MoPDSI and verified by
            provinces.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handlePDFDownload} autoFocus>
          Save as PDF
        </Button>
        <Button onClick={props.handleClosePDFPreview}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProjectSummaryPDFPreview;
